<template>
  <div>
    <InvoiceStatus :status="data.paymentStatus" />

    <RideList
      :data="data"
      :drawerType="drawerType"
      :filters="filters"
      @change="change"
    />
  </div>
</template>

<script>
import { isValidObject, isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import InvoiceStatus from 'components/GlobalDrawer/Financial/InvoiceStatus'
import RideList from 'components/GlobalDrawer/RideList'

export default {
  name: 'TabInfo',
  props: {
    data: {
      type: Object,
      required: true
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    InvoiceStatus,
    RideList
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.tabs'
    }
  },
  methods: {
    isValidObject (val) {
      return isValidObject(val)
    },

    isValidArray (val) {
      return isValidArray(val)
    },

    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>
